import { deleteDoc, doc } from "firebase/firestore";
import { db } from "shared/api/firebase";

export const deleteBulletin = async (bulletinId: string) => {
  const bulletinRef = doc(db, `bulletins/${bulletinId}`);
  await deleteDoc(bulletinRef);
};
